var map = {
	"./qzj_user_privacy_new_1.png": "fe1f",
	"./qzj_user_privacy_new_10.png": "570b",
	"./qzj_user_privacy_new_2.png": "1120",
	"./qzj_user_privacy_new_3.png": "bb00",
	"./qzj_user_privacy_new_4.png": "f139",
	"./qzj_user_privacy_new_5.png": "6a6d",
	"./qzj_user_privacy_new_6.png": "0264",
	"./qzj_user_privacy_new_7.png": "ad97",
	"./qzj_user_privacy_new_8.png": "a574",
	"./qzj_user_privacy_new_9.png": "b0d3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "097a";